import { ErrorResponse, PackingCategoryEnum } from '@gtpl/shared-models/common-models';
import { AllItemResponse, AssetsDropDown, AssetsDropDownResponseModel, GetItemForProductRequest, ItemDetailsResponse, ItemResponse, ItemsDropDownDto, ItemsDropDownResponseModel, ItemsDto, SizeRequest } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { ItemCategoriesService } from '../item-categories/item-categories.service';
import { VariantService } from '../item-varient/item-variant.service';
import { SizesService } from '../sizes/sizes.service';
import { getManager, In, IsNull, Repository } from 'typeorm';
import { BomItemRequest } from './dto/bom-item-request';
import { ItemAdapter } from './dto/item.adapter';
import { ItemDto } from './dto/item.dto';
import { ItemRequest } from './dto/item.request';
import { Item } from './item.entity';
import { EndCustomersService } from '../end-customer/end-customer.service';
import { SkuCodesService } from '../sku-codes/sku-codes.service';
import { UomsService } from '../uoms/uoms.service';
import { MasterBrandsService } from '../master-brands/master-brands.service';
import { RmBomItemRequest } from './dto/rm-bom-item-request';
import { GetItemsRequest } from './dto/get-items.request';
import { ItemSubCategoriesService } from '../item-sub-categories/item-sub-categories.service';
import { FoodTypesService } from '../food-types/food-types.service';
import { ValueAddition1TypesService } from '../value-addition1-types/value-addition1-types.service';
import { ValueAddition2TypesService } from '../value-addition2-types/value-addition2-types.service';
import { ValueAddition3TypesService } from '../value-addition3-types/value-addition3-types.service';
import { ValueAddition4TypesService } from '../value-addition4-types/value-addition4-types.service';
import { ValueAddition5TypesService } from '../value-addition5-types/value-addition5-types.service';
import { ItemForBrandReq } from './dto/item-for-brand-request';
import { ProductsService } from '../products/products.service';
import { ItemCodeRequest } from './dto/item-code.req';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import appSettings from 'apps/services/config';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { ItemBySubcategory } from './dto/item-by-subcategory';
import { Assets } from 'apps/services/asset-management/src/app/open-assets/open-assets-entity';
import { plantIdRequest } from '../rm-rack-position/dto/plant-request';

@Injectable()
export class ItemsService {

    constructor(
      private logService:LogsService,
        @InjectRepository(Item) private ItemRepository: Repository<Item>,
        private itemAdapter: ItemAdapter,
        private itemSize: SizesService,
        private brandService: MasterBrandsService,
        private skuService: SkuCodesService,
        private productService: ProductsService,
        private uomService: UomsService,
        private categoryService: ItemCategoriesService,
        private subCategoryService: ItemSubCategoriesService,
        private fTypeService: FoodTypesService,
        private v1Service: ValueAddition1TypesService,
        private v2Service: ValueAddition2TypesService,
        private v3Service: ValueAddition3TypesService,
        private v4Service: ValueAddition4TypesService,
        private v5Service: ValueAddition5TypesService,

    ) { }

    async createItem(itemDto: ItemDto, isUpdate: boolean, request: Request): Promise<ItemResponse> {
        try {
            // if (!isUpdate) {
                let itemEntity;
                let sizeName = null;
                itemDto.itemCategoryId = (await this.categoryService.getItemCategoryByName({ itemCategory: itemDto.itemCategoryName })).itemCategoryId || null;

                if (!itemDto.itemSubCategoryId) {
                    itemDto.itemSubCategoryId = (await this.subCategoryService.getItemSubCategoryForBomItem(itemDto.packingCategory, itemDto.packingCategory)).itemSubCategoryId || null;
                }

                if (itemDto.packingCategory) {
                    
                    if (itemDto.packingCategory != PackingCategoryEnum.CARTON) {
                        itemDto.pouches = 1;
                    }

                    // get brand details
                    let brandName = ''
                    if(itemDto.brandId){
                        brandName = (await this.brandService.getMasterBrandById(itemDto.brandId)).masterBrandName.trim() + "/" || null;
                    }

                    // get sku information
                    let itemVariant = '';

                    if (itemDto.varientId) {
                        itemVariant = (await this.skuService.getSkuCodeById(itemDto.varientId)).variantCode.trim() || null;
                    }

                    let grade = '';
                    if (itemDto.minGrade && itemDto.maxGrade) {

                        grade = itemDto.minGrade + "-" + itemDto.maxGrade + "/";
                    }
                    let packStyle = '';
                    if (itemDto.pouches && itemDto.pouchWeight) {
                        if (itemDto.packingCategory == PackingCategoryEnum.POUCH || itemDto.packingCategory == PackingCategoryEnum.SKEWER) {
                            packStyle = Number(itemDto.pouchWeight) + '';
                            itemDto.pouches = undefined;
                        } else {
                            packStyle = itemDto.pouches + "*" + Number(itemDto.pouchWeight)
                        }
                    }

                    let bapNo = '';
                    if (itemDto.bapNo) {
                        bapNo = itemDto.bapNo.trim() + "/";
                    }

                    let product = '';
                    if (itemDto.productId) {
                        product = (await this.productService.getProductById(itemDto.productId)).productCode.trim();
                    }

                    let fType = '';
                    if (itemDto.foodTypeId) {
                        fType = (await this.fTypeService.getFoodTypeById(itemDto.foodTypeId)).foodTypeCode.trim();
                    }


                    let v1 = '';
                    if (itemDto.valueAdditionOneId) {
                        v1 = (await this.v1Service.getValAddTypeById(itemDto.valueAdditionOneId)).code.trim();
                    }

                    let v2 = '';
                    if (itemDto.valueAdditionTwoId) {
                        v2 = (await this.v2Service.getValAddTypeById(itemDto.valueAdditionTwoId)).code.trim();
                    }

                    let v3 = '';
                    if (itemDto.valueAdditionThreeId) {
                        v3 = (await this.v3Service.getValAddTypeById(itemDto.valueAdditionThreeId)).code.trim();
                    }

                    let v4 = '';
                    if (itemDto.valueAdditionFourId) {
                        v4 = (await this.v4Service.getValAddTypeById(itemDto.valueAdditionFourId)).code.trim();
                    }

                    let v5 = '';
                    if (itemDto.valueAdditionFiveId) {
                        v5 = (await this.v5Service.getValAddTypeById(itemDto.valueAdditionFiveId)).code.trim();
                    }

                    const v = (product+fType + v1 + v2 + v3 + v4 + v5) ? (product+fType + v1 + v2 + v3 + v4 + v5).toLocaleUpperCase().trim() + "/" : '';

                    // get uom information
                    let uomName = '';
                    if(itemDto.uomId){
                        uomName = (await this.uomService.getUomById(itemDto.uomId)).uomName || null;
                    }


                    // get size information
                    if (itemDto.sizeId) {
                        sizeName = (await this.itemSize.getSize(itemDto.sizeId)).sizeName.trim()  || null;
                    }

                    let itemName = itemDto.itemName;
                    if ((itemDto.packingCategory == PackingCategoryEnum.SKEWER) || (itemDto.packingCategory == PackingCategoryEnum.RING) || (itemDto.packingCategory == PackingCategoryEnum.PLATTER)) {
                        if (!itemDto.itemName) {
                            itemName = itemDto.packingCategory +"/"+sizeName;
                        }
                        if(!isUpdate){
                            itemEntity = await this.findDuplicateItemData(itemDto.brandId, itemDto.packingCategory, itemDto.varientId, itemDto.minGrade, itemDto.maxGrade, itemDto.pouches, Number(itemDto.pouchWeight), itemDto.uomId, itemName, itemDto.sizeId, itemDto.bapNo, itemDto.foodTypeId, itemDto.valueAdditionOneId, itemDto.valueAdditionTwoId, itemDto.valueAdditionThreeId, itemDto.valueAdditionFourId, itemDto.valueAdditionFiveId,itemDto.productId,itemDto.type,itemDto.netWeight);
                            if (itemEntity) {
                                return new ItemResponse(false, 9999, 'Item Already Exist',itemEntity);
                            }
                        }

                    } else {
                        if (!itemDto.itemName) {
                            itemName = itemDto.packingCategory + "/" + brandName + grade  + v + bapNo + packStyle + uomName;
                            itemDto.sizeId = (await this.itemSize.getSizeId('N/A',itemDto.itemSubCategoryId)).sizeId || null;
                        }
                        if(!isUpdate){

                            itemEntity = await this.findDuplicateItemData(itemDto.brandId, itemDto.packingCategory, itemDto.varientId, itemDto.minGrade, itemDto.maxGrade, itemDto.pouches, Number(itemDto.pouchWeight), itemDto.uomId, itemName, itemDto.sizeId, itemDto.bapNo, itemDto.foodTypeId, itemDto.valueAdditionOneId, itemDto.valueAdditionTwoId, itemDto.valueAdditionThreeId, itemDto.valueAdditionFourId, itemDto.valueAdditionFiveId,itemDto.productId,itemDto.type,itemDto.netWeight);
                            if (itemEntity) {
                                return new ItemResponse(false, 9999, 'Item Already Exist',itemEntity);
                            }
                        }
                    }
                    itemDto.itemName = itemName;
                } else {
                    if (!itemDto.sizeId) {
                        itemDto.sizeId = (await this.itemSize.getSizeId('N/A',itemDto.itemSubCategoryId)).sizeId || null;
                    }
                    itemEntity = await this.checkItemExisted(itemDto.itemName, itemDto.sizeId);
                    if (itemEntity) {
                        return new ItemResponse(false, 9999, 'Item Already Exist');
                    }
                }
            // }

            if(itemDto.itemId && itemDto.assetType){
                const manager = getManager()
                const statusSaveQry = `update ${appSettings.assets_db}.assets set asset_type = '${itemDto.assetType}' where assets_name = ${itemDto.itemId}`
                const updateAssset = await manager.query(statusSaveQry);
                console.log('updateAssset',updateAssset)
                if(!(updateAssset.affectedRows)){
                    return new ItemResponse(false, 9999, 'Something went wrong in asset update.');
                }
            }
            


            const convertedItemEntity: Item = this.itemAdapter.convertDtoToEntity(itemDto, isUpdate);
            const savedItemEntity: Item = await this.ItemRepository.save(convertedItemEntity);
            const savedItemDto: ItemDto = this.itemAdapter.convertEntityToDto(savedItemEntity);
            console.log('savedItemDto' + savedItemDto)
            if (savedItemDto) {
                const response = new ItemResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Item Updated Successfully' : 'Item Created Successfully', savedItemDto);
                const name=isUpdate?'updated':'created'
                const newLogDto = new LogsDto(1,name, 'Item', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res,'123');
                return response;
            } else {
                return new ItemResponse(false, 9999, 'Item saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }


    /**
     * gets all   Item  details  
     * @returns all the  Item  details .
     */
    // @LogActions({ isAsync: true })
    async getAllItems(): Promise<AllItemResponse> {
        const itemDto: ItemDto[] = [];
        // retrieves all plants
        const itemEntities: Item[] = await this.ItemRepository.find({
            order: { itemName: "ASC" },
            relations: ['itemCategoryInfo', 'itemSubCategory', 'brandsInfo', 'skuInfo', 'uomInfo', 'sizeInfo', 'productInfo','foodTypeInfo','valueAdditionOneTypeInfo','valueAdditionTwoTypeInfo','valueAdditionThreeTypeInfo','valueAdditionFourTypeInfo','valueAdditionFiveTypeInfo'],
            
        });
        //   console.log(itemEntities);
        if (itemEntities && itemEntities.length > 0) {
            itemEntities.forEach(itemEntity => {
                const convertedItemDto: ItemDto = this.itemAdapter.convertEntityToDto(itemEntity);
                itemDto.push(convertedItemDto);
            });
            const response = new AllItemResponse(true, 11208, "Item retrieved successfully", itemDto);
            console.log(itemDto,'-----itemdto')
            const newLogDto = new LogsDto(1,'view', 'Item', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
        } else {
            //   console.log('yest')
            throw new ItemResponse(false,99998, 'No Records Found');
        }

    }

    /**
     * gets all   Item  details  
     * @returns all the  Item  details .
     */
    // @LogActions({ isAsync: true })
    async getTotalItemDataById(itemReq: ItemRequest): Promise<ItemResponse> {
        try {
            // const itemDto: ItemDto = ;
            // retrieves all plants
            const itemEntity: Item = await this.ItemRepository.findOne({
                relations: ['productInfo', 'itemCategoryInfo', 'brandsInfo', 'sizeInfo', 'uomInfo', 'skuInfo', 'itemSubCategory','valueAdditionOneTypeInfo','valueAdditionTwoTypeInfo','valueAdditionThreeTypeInfo','valueAdditionFourTypeInfo','valueAdditionFiveTypeInfo','foodTypeInfo'],
                where: { itemId: itemReq.itemId }
            });
            if (itemEntity) {

                const convertedItemDto: ItemsDto = this.itemAdapter.convertEntityToDto(itemEntity);

                const response = new ItemResponse(true, 11208, "Item retrieved successfully", convertedItemDto);

                return response;
            } else {
                //   console.log('yest')
                throw new ItemResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getTotalItemDataByCode(itemReq: ItemCodeRequest): Promise<CommonResponse> {
        try {
            // const itemDto: ItemDto = ;
            // retrieves all plants
            const itemEntity: Item = await this.ItemRepository.findOne({
                where: { itemCode: itemReq.itemCode}
            });
            console.log(itemEntity)
            if (itemEntity) {
                const itemsDto = new ItemDto;
                itemsDto.itemName = itemEntity.itemName;
                itemsDto.itemId = itemEntity.itemId;
                const response = new CommonResponse(true, 11208, "Item retrieved successfully", itemsDto);

                return response;
            } else {
                //   console.log('yest')
                throw new ItemResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async checkItemExisted(itemName: string, sizeId: number): Promise<Item> {
        //  console.log(employeeId);
        const response = await this.ItemRepository.findOne({
            where: { itemName: itemName, sizeInfo: sizeId },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getItem(itemName: string): Promise<Item> {
        //  console.log(employeeId);
        const response = await this.ItemRepository.findOne({
            where: { itemName: itemName },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;
        }
    }


    async findDuplicateItemData(brand: number, packingCategory: string, varientId: number, minGrade: number, maxGrade: number, pouches: number, pouchWeight: number, uomId: number, itemName: string, sizeId?: number, bapNo?: string, foodTypeId?: number, vOneId?: number, vTwoId?: number, vThreeId?: number, vFourId?: number, vFiveId?: number,productId?:number,type?:number,netWeight?:number): Promise<Item> {

        console.log(brand, packingCategory, varientId, minGrade, maxGrade, pouches, pouchWeight, uomId, itemName, sizeId, bapNo, foodTypeId, vOneId, vTwoId, vThreeId, vFourId, vFiveId);

        //  console.log(employeeId);
        if ((packingCategory == PackingCategoryEnum.SKEWER || (packingCategory == PackingCategoryEnum.RING) || (packingCategory == PackingCategoryEnum.PLATTER))) {
            const response = await this.ItemRepository.findOne({
                where: {isActive:true, brandsInfo: (brand) ? brand : IsNull() , minGrade: (minGrade) ? minGrade : IsNull(), maxGrade: (maxGrade) ? maxGrade : IsNull(), pouches: (pouches) ? pouches : IsNull(), pouchWeight: (pouchWeight) ? pouchWeight : IsNull(), packingCategory: (packingCategory) ? packingCategory : IsNull(), uomInfo: (uomId) ? uomId : IsNull(), sizeInfo: (sizeId) ? sizeId : IsNull(), bapNo: (bapNo) ? bapNo : IsNull(), foodTypeInfo: (foodTypeId) ? foodTypeId : IsNull(), valueAdditionOneTypeInfo: (vOneId) ? vOneId : IsNull(), valueAdditionTwoTypeInfo: (vTwoId) ? vTwoId : IsNull(), valueAdditionThreeTypeInfo: (vThreeId) ? vThreeId : IsNull(), valueAdditionFourTypeInfo: (vFourId) ? vFourId : IsNull(), valueAdditionFiveTypeInfo: (vFiveId) ? vFiveId : IsNull(),productInfo: (productId) ? productId : IsNull(),type:(type) ? type : IsNull(),netWeight : (netWeight) ? netWeight : IsNull() },
            });
            // console.log(response);
            if (response) {
                return response;
            } else {
                return null;
            }
        } else {
            const response = await this.ItemRepository.findOne({
                where: {isActive:true,brandsInfo: (brand) ? brand : IsNull() , minGrade: (minGrade) ? minGrade : IsNull(), maxGrade: (maxGrade) ? maxGrade : IsNull(), pouches: (pouches) ? pouches : IsNull(), pouchWeight: (pouchWeight) ? pouchWeight : IsNull(), packingCategory: (packingCategory) ? packingCategory : IsNull(), uomInfo: (uomId) ? uomId : IsNull(),sizeInfo: (sizeId) ? sizeId : IsNull(),  bapNo: (bapNo) ? bapNo : IsNull(), foodTypeInfo: (foodTypeId) ? foodTypeId : IsNull(), valueAdditionOneTypeInfo: (vOneId) ? vOneId : IsNull(), valueAdditionTwoTypeInfo: (vTwoId) ? vTwoId : IsNull(), valueAdditionThreeTypeInfo: (vThreeId) ? vThreeId : IsNull(), valueAdditionFourTypeInfo: (vFourId) ? vFourId : IsNull(), valueAdditionFiveTypeInfo: (vFiveId) ? vFiveId : IsNull(),productInfo: (productId) ? productId : IsNull(),type:(type) ? type : IsNull(),netWeight : (netWeight) ? netWeight : IsNull(), itemName: (itemName ) ? itemName : IsNull()  },
            });
            // console.log(response);
            if (response) {
                return response;
            } else {
                return null;
            }
        }


    }

    /**
     * It deactivates value  Item   
     * @param itemReq   item  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateItem(itemReq: ItemRequest): Promise<ItemResponse> {
        try {
            const itemExists = await this.getItemById(itemReq.itemId);
            if (itemExists) {
                if (itemReq.versionFlag !== itemExists.versionFlag) {
                    throw new ItemResponse(false,10113, 'Someone updated the current item information.Refresh and try again');
                } else {

                    const itemSatatus = await this.ItemRepository.update(
                        { itemId: itemReq.itemId },
                        { isActive: itemReq.isActive, updatedUser: itemReq.updatedUser });

                    if (itemExists.isActive) {
                        if (itemSatatus.affected) {
                            const itemResponse: ItemResponse = new ItemResponse(true, 10115, 'Item is de-activated successfully');
                            return itemResponse;
                        } else {
                            throw new ItemResponse(false,10111, 'Item is already deactivated');
                        }
                    } else {
                        if (itemSatatus.affected) {
                            const itemResponse: ItemResponse = new ItemResponse(true, 10114, 'Item is activated successfully');
                            return itemResponse;
                        } else {
                            throw new ItemResponse(false,10112, 'Item is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new ItemResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getItemById(itemId: number): Promise<Item> {
        //  console.log(employeeId);
        const response = await this.ItemRepository.findOne({
            where: { itemId: itemId },
            relations: ['sizeInfo']
        });

        console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
        console.log(response);

        if (response) {
            return response;
        } else {
            return null;
        }
    }



    /**
   * gets all items at given category   
   * @returns all items .
   */
    async getItemsByCategoryId(itemCatId: number): Promise<ItemsDropDownResponseModel> {
        try {
            const itemDTO: ItemsDropDownDto[] = [];
            const itemEntities: Item[] = await this.ItemRepository.find({ select: ['itemId', 'itemName'], where: { itemCategoryInfo: itemCatId, isActive: true }, order: { itemName: 'ASC' } });
            if (itemEntities && itemEntities.length > 0) {
                itemEntities.forEach(itemEntity => {
                    itemDTO.push(new ItemsDropDownDto(itemEntity.itemId, itemEntity.itemName));
                });
                const response = new ItemsDropDownResponseModel(true, 11108, "Item categories retrieved successfully", itemDTO);
                return response;
            } else {
                throw new ItemResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }


    async getItemForCategoryAndSubCat(req: GetItemsRequest): Promise<ItemsDropDownResponseModel> {
        try {
            const itemEntities: ItemsDropDownDto[] = await this.ItemRepository.createQueryBuilder()
                .select("Item.is_asset as isAsset,Item.item_id as itemId, CASE WHEN category.item_category = 'Packing Material' THEN item_name WHEN Item.size_id is null THEN item_name ELSE CONCAT(item_name, ' - ', sizeInfo.size_name) END AS itemName, sizeInfo.size_id as sizeId, sizeInfo.size_name as sizeName")
                .leftJoin('Item.itemCategoryInfo', 'category')
                .leftJoin('Item.itemSubCategory', 'subCategory')
                .leftJoin('Item.sizeInfo', 'sizeInfo')
                .where(`Item.is_active=1 and Item.item_category_id='${req.itemCategoryId}' and Item.item_sub_category_id='${req.itemSubCategoryId}'`)
                .orderBy('item_name')
                .getRawMany();


            if (itemEntities && itemEntities.length > 0) {
                const response = new ItemsDropDownResponseModel(true, 11108, "Items retrieved successfully", itemEntities);
                return response;
            } else {
                throw new ItemResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getItemDataById(itemReq: ItemRequest): Promise<ItemsDropDownDto> {
        try {
            const itemEntities: ItemsDropDownDto = await this.ItemRepository.createQueryBuilder()
                .select("Item.item_id as itemId, CASE WHEN category.item_category = 'Packing Material' THEN item_name WHEN Item.size_id is null THEN item_name ELSE CONCAT(item_name, ' - ', sizeInfo.size_name) END AS itemName, sizeInfo.size_id as sizeId, sizeInfo.size_name as sizeName,is_asset as isAsset")
                .leftJoin('Item.itemCategoryInfo', 'category')
                .leftJoin('Item.itemSubCategory', 'subCategory')
                .leftJoin('Item.sizeInfo', 'sizeInfo')
                .where(`Item.item_id='${itemReq.itemId}'`)
                .getRawOne();


            // const ItemEntities = await this.ItemRepository.findOne({
            //     select: ['itemId', 'itemName'],
            //     relations:['sizeInfo'],
            //     where: { itemId: itemReq.itemId }
            // });
            if (itemEntities) {
                return itemEntities;
            } else {
                throw new ItemResponse(false,99998, 'No Records Found');
            }
        }
        catch (error) {
            return error;
        }
    }

    /**
     * 
     * @param itemId 
     * @returns item details
     */
    async getItemForId(itemId: number): Promise<ItemDetailsResponse> {
        const response: ItemsDropDownDto = await this.ItemRepository.createQueryBuilder()
            .select("Item.item_id as itemId, CASE WHEN category.item_category = 'Packing Material' THEN item_name WHEN Item.size_id is null THEN item_name ELSE CONCAT(item_name, ' - ', sizeInfo.size_name) END AS itemName, sizeInfo.size_id as sizeId, sizeInfo.size_name as sizeName")
            .leftJoin('Item.itemCategoryInfo', 'category')
            .leftJoin('Item.itemSubCategory', 'subCategory')
            .leftJoin('Item.sizeInfo', 'sizeInfo')
            .where(`Item.item_id='${itemId}'`)
            .getRawOne();

        if (response) {
            return new ItemDetailsResponse(true, 1111, 'item details retrieved successfully', response);
        } else {
            return null;
        }
    }

    async getPouchItemForBom(bomItemreq: BomItemRequest): Promise<AllItemResponse | any> {
        let response;
        const depParams = bomItemreq.brandsData;
        let concatString = ''
        let index: number = 0
        let bapConsider = 'isPouchBapNoConsider'
        let GradeConsider = 'isPouchGradeConsider'
        let maxGradeConsider
        let variantConsider = 'isPouchVariantConsider'
        let productConsider = 'isPouchProductConsider'
        let foodTypeConsider = 'isPouchFoodTypeConsider'
        let valAddOneConsider = 'isPouchValAddOneConsider'
        let valAddTwoConsider = 'isPouchValAddTwoConsider'
        let valAddThreeConsider = 'isPouchValAddThreeConsider'
        let valAddFourConsider = 'isPouchValAddFourConsider'
        let valAddFiveConsider = 'isPouchValAddFiveConsider'
        if (bomItemreq.packingCategory == PackingCategoryEnum.CARTON) {
            bapConsider = 'isCartonBapNoConsider'
            // bomItemreq.packingCategory = 'Carton'
            GradeConsider = 'isCartonGradeConsider'
            productConsider = 'isCartonProductConsider'
            foodTypeConsider = 'isCartonFoodTypeConsider'
            valAddOneConsider = 'isCartonValAddOneConsider'
            valAddTwoConsider = 'isCartonValAddTwoConsider'
            valAddThreeConsider = 'isCartonValAddThreeConsider'
            valAddFourConsider = 'isCartonValAddFourConsider'
            valAddFiveConsider = 'isCartonValAddFiveConsider'
            // variantConsider = 'isCartonVariantConsider'
        }

        console.log('dattaaaaaaaxyzabcsss')
        console.log(bomItemreq)
        console.log(bapConsider)
        console.log(GradeConsider)
        console.log(variantConsider)
        if(bomItemreq.packingCategory ==  PackingCategoryEnum.POUCH ||  bomItemreq.packingCategory == PackingCategoryEnum.CARTON){
            console.log('hhhhoooooo')

            concatString = 'item_id>0 and is_active = 1 and brand=' + bomItemreq.brandId + ' and pouch_weight=' + bomItemreq.pouchWeight + (bomItemreq.brandsData[bapConsider] ? ' and bap_no="' + bomItemreq.bapNo+'"' : '') + (bomItemreq.brandsData[GradeConsider] ? (' and min_grade=' + bomItemreq.minGrade + ' And ' + 'max_grade=' + bomItemreq.maxGrade) : '') + (bomItemreq.brandsData[productConsider] ? (' and product_id=' + bomItemreq.productId) : '') + (bomItemreq.brandsData[foodTypeConsider] ? (' and food_type_id=' + bomItemreq.foodType) : '') + (bomItemreq.brandsData[valAddOneConsider] ? (' and value_addition_one_id=' + bomItemreq.valueAdditionOneId) : '') + (bomItemreq.brandsData[valAddTwoConsider] ? (' and value_addition_two_id=' + bomItemreq.valueAdditionTwoId) : '') + (bomItemreq.brandsData[valAddThreeConsider] ? (' and value_addition_three_id=' + bomItemreq.valueAdditionThreeId) : '') + (bomItemreq.brandsData[valAddFourConsider] ? (' and value_addition_four_id=' + bomItemreq.valueAdditionFourId) : '') + (bomItemreq.brandsData[valAddFiveConsider] ? (' and value_addition_five_id=' + bomItemreq.valueAdditionFiveId) : '') + ' and packing_category="' + bomItemreq.packingCategory + '"'  + (bomItemreq.packingCategory == PackingCategoryEnum.CARTON ? (' and pouches=' + bomItemreq.pouches) : '')
        }
        if(bomItemreq.packingCategory ==  PackingCategoryEnum.SKEWER || bomItemreq.packingCategory ==  PackingCategoryEnum.RING || bomItemreq.packingCategory ==  PackingCategoryEnum.PLATTER){
            console.log('ttttt')
            concatString = 'item_id>0 and size_id=' + bomItemreq.sizeId + ' and packing_category="' + bomItemreq.packingCategory +'"'
        }
        response = await this.ItemRepository.createQueryBuilder()
            .select('item_id as itemId,item_category_id as itemCategoryId,packing_category as packingCategory,item_sub_category_id as itemSubCategoryId,size_id as sizeId')
            .where(concatString)
            .getRawOne();
        console.log('resssssssssss')
        console.log(response)
        if (response) {
            // const itemData = new ItemsDropDownDto(response.itemId, response.itemName)
            return new ItemResponse(true, 1111, 'item details retrieved successfully', response);
        } else {
            return null;
        }
    }



    /**
    * 
    * @param itemId 
    * @returns item details against grade, brand,varient and packstyle
    */
    async getItemForBom(bomItemreq: BomItemRequest): Promise<AllItemResponse | any> {
        let response;
        if (bomItemreq.sizeId) {

            //   if(bomItemreq.packingCategory == 'Pouch'){
            response = await this.ItemRepository.findOne({
                where: { packingCategory: 'Skewer', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: 1, pouchWeight: bomItemreq.pouchWeight, sizeInfo: { sizeId: bomItemreq.sizeId }, uomInfo: { uomId: bomItemreq.uomId } },
                relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
            });
            //   }

        } else {


            if (bomItemreq.packingCategory == 'Ring') {
                const CartonRes = await this.ItemRepository.find({
                    where: { packingCategory: 'Carton', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: bomItemreq.pouches, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                const ringRes = await this.ItemRepository.find({
                    where: { packingCategory: 'Ring', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: 1, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                response = [...CartonRes, ...ringRes]
            } else if (bomItemreq.packingCategory == PackingCategoryEnum.PLATTER) {
                const platterresponse = await this.ItemRepository.find({
                    where: { packingCategory: 'Platter', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: 1, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                const cartonresponse = await this.ItemRepository.find({
                    where: { packingCategory: 'Carton', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: bomItemreq.pouches, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                response = [...platterresponse, ...cartonresponse]
            } else {
                const pouchresponse = await this.ItemRepository.find({
                    where: { packingCategory: 'Pouch', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: 1, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                const cartonresponse = await this.ItemRepository.find({
                    where: { packingCategory: 'Carton', minGrade: bomItemreq.minGrade, maxGrade: bomItemreq.maxGrade, brandsInfo: { brandId: bomItemreq.brandId }, skuInfo: { skuCodeId: bomItemreq.varientId }, pouches: bomItemreq.pouches, pouchWeight: bomItemreq.pouchWeight, uomInfo: { uomId: bomItemreq.uomId } },
                    relations: ['itemCategoryInfo', 'sizeInfo', 'itemSubCategory']
                });
                response = [...pouchresponse, ...cartonresponse];
            }
        }
        if (response) {
            // const itemData = new ItemsDropDownDto(response.itemId, response.itemName)
            return new ItemResponse(true, 1111, 'item details retrieved successfully', response);
        } else {
            return null;
        }
    }

    /**
    * 
    * @param itemId 
    * @returns item details against product, count
    */
    async getRmItemForBom(bomItemreq: RmBomItemRequest): Promise<AllItemResponse | any> {
        let response;
        console.log(bomItemreq);
        response = await this.ItemRepository.findOne({
            where: { productInfo: { productId: bomItemreq.productId }, count: bomItemreq.count },
            relations: ['itemCategoryInfo', 'itemSubCategory']
        });

        if (response) {
            // const itemData = new ItemsDropDownDto(response.itemId, response.itemName)
            return new ItemResponse(true, 1111, 'item details retrieved successfully', response);
        } else {
            return null;
        }
    }

    async getItemsDropDownData(): Promise<ItemsDropDownResponseModel> {
        try {
            const itemDTO: ItemsDropDownDto[] = [];
            const itemEntities: Item[] = await this.ItemRepository.find({ select: ['itemId', 'itemName'], where: { isActive: true }, order: { itemName: 'ASC' } });
            if (itemEntities && itemEntities.length > 0) {
                itemEntities.forEach(itemEntity => {
                    itemDTO.push(new ItemsDropDownDto(itemEntity.itemId, itemEntity.itemName));
                });
                const response = new ItemsDropDownResponseModel(true, 11108, "Item categories retrieved successfully", itemDTO);
                return response;
            } else {
                throw new ItemResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getPMItemsDropDownData(): Promise<ItemsDropDownResponseModel> {
        try {
            const itemDTO: ItemsDropDownDto[] = [];
            const itemEntities: Item[] = await this.ItemRepository.find({ select: ['itemId', 'itemName'], where: { isActive: true, itemCategoryInfo:{itemCategoryId: 6}}, order: { itemName: 'ASC' } });
            if (itemEntities && itemEntities.length > 0) {
                itemEntities.forEach(itemEntity => {
                    itemDTO.push(new ItemsDropDownDto(itemEntity.itemId, itemEntity.itemName));
                });
                const response = new ItemsDropDownResponseModel(true, 11108, "Item categories retrieved successfully", itemDTO);
                return response;
            } else {
                throw new ItemResponse(false,99998, 'Data not found');
            }
        } catch (err) {
            return err;
        }
    }

    async getItemForProduct(bomItemreq: GetItemForProductRequest): Promise<AllItemResponse | any> {
        let response;
        response = await this.ItemRepository.findOne({
            where: { productInfo: { productId: bomItemreq.productId }, itemId: bomItemreq.itemId },
            relations: ['itemCategoryInfo']
        });

        if (response) {
            return new ItemResponse(true, 1111, 'item details retrieved successfully', response);
        } else {
            return null;
        }
    }

    async getItemForBrandAndSubCategory(req:ItemForBrandReq) :Promise<ItemsDropDownResponseModel> {
        try{
            const manager = getManager()
            // let itemDTO: any[] = [];
            console.log(req,'req-------')
        //    const itemEntities : Item[] = await this.ItemRepository.find({ select: ['itemId', 'itemName' ,'sizeInfo'], where: { isActive: true, brandsInfo:{masterBrandId :req.brandId},itemSubCategory:{itemSubCategoryId:req.itemSubCategoryId}}, order: { itemName: 'ASC' },relations:['sizeInfo'] });
            console.log('--------items--------')
            let itemsDataQry = `select item_id as itemId,item_name as itemName from ${appSettings.masters_db}.items i left join master_brands mb on mb.master_brand_id = i.brand left join item_sub_categories isc on isc.item_sub_category_id = i.item_sub_category_id where i.is_active = true and i.item_sub_category_id = ${req.itemSubCategoryId}`;
            if(req.brandId > 0){
                itemsDataQry = itemsDataQry+` and brand = ${req.brandId}`
            }
            const itemDTO = await manager.query(itemsDataQry)

            if (itemDTO.length > 0 ) {
                // itemEntities.forEach(itemEntity => {
                //     itemDTO.push(new ItemsDropDownDto(itemEntity.itemId, itemEntity.itemName,'',itemEntity.sizeInfo.sizeId));
                // });
                const response = new ItemsDropDownResponseModel(true, 11108, "Itezms retrieved 'successfully", itemDTO);
                console.log(response)
                return response;
                
            } else {
                throw new ItemResponse(false,99998, 'No Items for given Brand and Item sub category');
            }

        }catch(err){
            return err
        }

    }

    async getItemsForSubCategory(req:ItemForBrandReq) :Promise<ItemsDropDownResponseModel> {
        try{
            const itemDTO: ItemsDropDownDto[] = [];
            console.log(req,'req-------')
           const itemEntities : Item[] = await this.ItemRepository.find({ select: ['itemId', 'itemName' ,'sizeInfo'], where: { isActive: true,itemSubCategory:{itemSubCategoryId:req.itemSubCategoryId}}, order: { itemName: 'ASC' },relations:['sizeInfo'] });
            if (itemEntities && itemEntities.length > 0 ) {
                itemEntities.forEach(itemEntity => {
                    itemDTO.push(new ItemsDropDownDto(itemEntity.itemId, itemEntity.itemName,'',itemEntity?.sizeInfo?.sizeId));
                });
                const response = new ItemsDropDownResponseModel(true, 11108, "Items retrieved 'successfully", itemDTO);
                console.log(response)
                return response;
                
            } else {
                throw new ItemResponse(false,99998, 'No Items found for given Item sub category');
            }
        }catch(err){
            return err
        }

    }
    async getitemsforsubcategories(req:ItemForBrandReq): Promise<CommonResponse>{
        try{
          let query;
          const manager= getManager();
          if(req.saleOrderId != 0){
            let mainsoitemId ='SELECT main_so_item_id AS mainsoItem FROM '+appSettings.sales_db+'.sale_order_items WHERE sale_order_id ='+req.saleOrderId+''
            const mainsoitemIdreq = await manager.query(mainsoitemId)
            
            let MainjobsaleOrderId = 'SELECT si.sale_order_id AS saleOrderId FROM '+appSettings.sales_db+'.sale_order_items si LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sd ON si.sale_order_id=sd.sale_order_id WHERE si.main_so_item_id='+mainsoitemIdreq[0].mainsoItem+' AND job_type="Main Job"'
            const MainjobsaleOrderIdreq = await manager.query(MainjobsaleOrderId)

            query='  SELECT b.item_id AS itemId,b.item_sub_category_id AS itemSubCategoryId,sale_order_id AS saleOrderId,item_name AS itemName FROM `erpx_dev_sales`.`bom_details` b LEFT JOIN `erpx_dev_masters`.`items` i ON i.item_id=b.item_id where b.item_sub_category_id='+req.itemSubCategoryId+' AND sale_order_id='+MainjobsaleOrderIdreq[0].saleOrderId+' '
          }else{
            query='  SELECT b.item_id AS itemId,b.item_sub_category_id AS itemSubCategoryId,sale_order_id AS saleOrderId,item_name AS itemName FROM `erpx_dev_sales`.`bom_details` b LEFT JOIN `erpx_dev_masters`.`items` i ON i.item_id=b.item_id where b.item_sub_category_id='+req.itemSubCategoryId+' '
          }
        //   const query = 'SELECT item_name AS itemName,item_id AS itemId,item_sub_category_id FROM `erpx_dev_masters`.`items` WHERE item_sub_category_id='+req.itemSubCategoryId+'';
        
          const result =await manager.query(query)
          if (result) {
            return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
          } else {
            return new CommonResponse(false, 1111, "Error occure")
      
          }
      
        }catch(err){
          return err;
        }
      
      }

    async getItemForItemId(req:ItemRequest):Promise<CommonResponse>{
        try{
            let query;
            const manager= getManager();
            query='SELECT i.item_id AS itemId,i.item_sub_category_id AS itemSubCategoryId,i.item_name AS itemName, i.brand AS brand FROM '+appSettings.masters_db+'.items i where i.item_id ='+req.itemId;
            const result =await manager.query(query)
            if (result) {
            return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
            return new CommonResponse(false, 1111, "Error occure")
        
            }
        }catch(err){
            return new CommonResponse(false, 1111, "Error occure")
        }
    }

    async getAllGeneralItems(req: ItemBySubcategory): Promise<CommonResponse> {
        console.log(req,'----req')
        const itemDto: ItemDto[] = [];
        const itemEntities: Item[] = await this.ItemRepository.find({
            order: { itemName: "ASC" },
            relations: ['itemCategoryInfo', 'itemSubCategory', 'brandsInfo', 'skuInfo', 'uomInfo', 'sizeInfo', 'productInfo','foodTypeInfo','valueAdditionOneTypeInfo','valueAdditionTwoTypeInfo','valueAdditionThreeTypeInfo','valueAdditionFourTypeInfo','valueAdditionFiveTypeInfo'],
            // where:{itemCategoryInfo:{itemCategoryId: 33}}
            where:{itemSubCategory:{itemSubCategoryId: req.itemSubCategoryId,isAsset:'yes'}}
        });
        console.log(itemEntities,"************")
        if (itemEntities && itemEntities.length > 0) {
            itemEntities.forEach(itemEntity => {
                const convertedItemDto: ItemDto = this.itemAdapter.convertEntityToDto(itemEntity);
                itemDto.push(convertedItemDto);
            });
            const response = new CommonResponse(true, 11208, "Item retrieved successfully", itemDto);
            return response;
        } else {
            //   console.log('yest')
            return new CommonResponse(false,99998, 'No Records Found');
        }

    }
    async getAssetDropdown() :Promise<AssetsDropDownResponseModel> {
        try{
            const manager= getManager();
            let query = "Select i.item_id AS assetId, i.item_name AS assetCode from "+appSettings.masters_db+".items i left join "+appSettings.assets_db+".assets a on a.assets_name = i.item_id where i.is_asset ='YES' and i.asset_type = 'movable' group by i.item_id";
            let result = await manager.query(query);
            if (result && result.length > 0 ) {
                const response = new AssetsDropDownResponseModel(true, 11108, "Items retrieved 'successfully", result);
                console.log(response)
                return response;
                
            } else {
                return new AssetsDropDownResponseModel(false,99998, 'No Items found. ');
            }
        }catch(err){
            return err
        }

    }
}
